import { render, staticRenderFns } from "./ModalEditStudentData.vue?vue&type=template&id=0b9c313a&scoped=true&lang=pug&"
import script from "./ModalEditStudentData.vue?vue&type=script&lang=ts&"
export * from "./ModalEditStudentData.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditStudentData.vue?vue&type=style&index=0&id=0b9c313a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c313a",
  null
  
)

export default component.exports